// extracted by mini-css-extract-plugin
export default {"behaviorAndScopeInfo":"Confirmation_behaviorAndScopeInfo__-EOyY","exclusionInfo":"Confirmation_exclusionInfo__VlKj7","exclusionNumber":"Confirmation_exclusionNumber__KqmVe"};